import { IServicePackageItemV4 } from '../../../repositories/billing-service-packages-balancer/entities/Purchase/ServicePackageItemV4';
import { IBuyPackageService } from '../../../types/packages';

export const mapService = (service: IBuyPackageService): IServicePackageItemV4 => {
  const { serviceType, count, price, marketingPrice, auctionPoints } = service;

  return {
    serviceType: serviceType as string as IServicePackageItemV4['serviceType'],
    count,
    price,
    marketingPrice,
    auctionPoints,
  };
};
